<template>
	<footer id="footer" role="contentinfo" class="p-0 m-0 py-sm-2">
		<div class="container-xl">
			<a href="https://www.protezionecivile.fvg.it/" class="footer_title">
        PROTEZIONE CIVILE DELLA REGIONE
      </a>
			<small class="footer_copyright d-block d-sm-inline">
				© 2020-2023 - Protezione Civile della Regione
        <span class="d-none d-sm-inline"> Autonoma Friuli Venezia Giulia / via Natisone 43, Palmanova (UD)</span><span class="d-inline d-sm-none">FVG</span>
			</small>
		</div>
	</footer>
</template>

<style>
</style>
